<span class="av-pointer-sender">{{ sender }}</span>
